import classNames from 'classnames';
import { Avatar, Card } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import { markIsFraud } from 'services/user.service';
import { useCallback } from 'react';
import { getOrdersByIdQueryKey } from 'hooks/api';
import { GoogleIcon } from 'components/icons';

import styles from './index.module.scss';
import { DeliveryInfo } from '../DeliveryInfo';

export interface UserInfoProps {
  order: Order.Item,
  className: string,
}

export const UserInfo = ({ order, className }: UserInfoProps) => {
  const { mutateAsync: markIsFraudMutate, isLoading } = useMutation(markIsFraud);
  const client = useQueryClient();

  const handleMarkIsFraud = useCallback(() => {
    markIsFraudMutate(order?.user?._id).then(() => {
      client.setQueryData([getOrdersByIdQueryKey, order._id], (o: Order.Item) => {
        o.user.isFraud = true;
        return o;
      });
    });
  }, []);

  return (
    <Card
      title='User info'
      className={classNames(styles.card, className)}
      aria-colspan={8}
    >
      <div className={styles.avatar}>
        <Avatar>{order.deliveryInfo.name?.substring(0, 1)}</Avatar>
        <div className={styles.avatarTitle}>{order?.deliveryInfo.name}</div>
        <div className={styles.avatarTitle}>{order?.deliveryInfo.lastname}</div>
        { order?.user?.isGoogleAccount && <GoogleIcon className={styles.googleIcon} /> }
      </div>
      <DeliveryInfo order={order} className={styles.card} />
    </Card>
  );
};
